import React from 'react';
import {Link, Typography} from '@mui/material';
import withMainContainer from '../../components/WithMainContainer.js';
import {withTitle} from '../../title.js';
import LegalContentWrapper from './LegalContentWrapper.js';
import LegalSection from './LegalSection.js';

const Terms = ()=><LegalContentWrapper title="תנאי שימוש" lastUpdated="08.08.2025">
  <LegalSection title="הקדמה">
    <Typography>
      ברוכים הבאים לאתר simonacherry.com, המופעל על-ידי סימונה צ'רי (להלן: "האתר").<br/>
      האתר כולל תכנים, בלוג, כתבות, שירותים מקוונים, ואפליקציות כגון אפליקציית מסרים אישיים ואזור אישי לתלמידים. בעתיד ייתכן שיוצעו גם קורסים מקוונים ומוצרים נוספים.
    </Typography>
    <Typography>
      השימוש באתר ו/או בתוכנו ו/או בשירותים המוצעים בו כפוף להסכמתך לתנאים המפורטים במסמך זה. אם אינך מסכים לתנאים - אינך רשאי לעשות שימוש באתר.<br/>
      עצם השימוש באתר מהווה את הסכמתך המלאה והבלתי חוזרת לכל תנאי המסמך, ומסיר כל טענה ו/או תביעה ו/או דרישה כלפי בעלת האתר, מפעיליו או מי מטעמם.
    </Typography>
  </LegalSection>
  <LegalSection title="1. תנאי סף ושינויים">
    <Typography>
      1.1 אין לעשות באתר כל שימוש שאינו מותר במפורש בתנאים אלה, לרבות שימוש מסחרי ללא אישור בכתב ומראש.
    </Typography>
    <Typography>
      1.2 אנו רשאים לשנות את תנאי השימוש בכל עת, ללא הודעה מוקדמת. השימוש באתר לאחר עדכון התנאים מהווה הסכמה לגרסה המעודכנת.
    </Typography>
    <Typography>
      1.3 אנו רשאים להפסיק את פעילות האתר, כולה או חלקה, בכל עת וללא הודעה מוקדמת.
    </Typography>
  </LegalSection>
  <LegalSection title="2. קישורים ותכני צד שלישי">
    <Typography>
      האתר עשוי לכלול קישורים לאתרים חיצוניים ותכנים של צדדים שלישיים. שימוש בתכנים אלו נעשה על אחריות המשתמש בלבד. בעלת האתר אינה אחראית לתוכן, לאמינותו, לאיכותו או לעדכניותו של כל מידע חיצוני.
    </Typography>
  </LegalSection>
  <LegalSection title="3. קניין רוחני">
    <Typography>
      3.1 כל התכנים, העיצובים, האפליקציות, הממשקים, הטקסטים, הסרטונים, התמונות, קבצי המדיה והקוד באתר מוגנים בזכויות יוצרים וחלים עליהם דיני הקניין הרוחני בישראל ובעולם, למעט תכנים שבהם הזכויות שייכות לצדדים שלישיים (כגון תמונות מאגר חוקיות).
    </Typography>
    <Typography>
      3.2 אין להעתיק, לשכפל, לצלם, להקליט, לתרגם, להפיץ, לשחזר או לקלוט בכל אמצעי, כל חלק מהאתר, למטרות מסחריות, ללא אישור בכתב ומראש מבעלת האתר.
    </Typography>
  </LegalSection>
  <LegalSection title="4. הגבלת אחריות">
    <Typography>
      4.1 השימוש באתר הוא על אחריותך הבלעדית והמלאה.
    </Typography>
    <Typography>
      4.2 כל המידע באתר ניתן לצורך העשרה והכוונה כללית בלבד, ואינו מהווה תחליף לייעוץ מקצועי (רפואי, משפטי, פיננסי, פסיכולוגי וכיו"ב).
    </Typography>
    <Typography>
      4.3 בעלת האתר ומי מטעמה אינם אחראים לנכונות, לעדכניות, להתאמה, לטעויות, להשמטות או להפסקות פעילות האתר, ולא יישאו בכל אחריות לנזקים ישירים או עקיפים שייגרמו כתוצאה מהשימוש בו.
    </Typography>
    <Typography>
      4.4 האתר עשוי להסתמך על שירותים חיצוניים (כגון ספקי אחסון או דיוור), ובעלת האתר אינה אחראית לכל תקלה או שינוי בשירותים אלו.
    </Typography>
  </LegalSection>
  <LegalSection title="5. פרטיות">
    <Typography>
      5.1 במסגרת השימוש באתר ייתכן שתתבקש למסור פרטים אישיים (שם, טלפון, מייל) וייאסף מידע טכני הקשור לשימושך (למשל Cookies לצורך התחברות לאזור התלמידים).
    </Typography>
    <Typography>
      5.2 השימוש במידע יתבצע בהתאם לחוק הגנת הפרטיות, התשמ"א-1981, ול<Link href="/privacy-policy">מדיניות הפרטיות</Link> המפורסמת באתר, ומהווה חלק בלתי נפרד מתנאי שימוש אלה.
    </Typography>
  </LegalSection>
  <LegalSection title="6. דיוור">
    <Typography>
      באמצעות מסירת פרטי התקשרותך והסכמה מפורשת לכך, הנך מאשר קבלת עדכונים, הצעות, ותוכן שיווקי בהתאם להוראות חוק התקשורת (בזק ושידורים), התשמ"ב-1982. ניתן להסיר את עצמך בכל עת באמצעות הקישור המיועד או פניה ישירה.
    </Typography>
  </LegalSection>
  <LegalSection title="7. שימוש אסור">
    <Typography>
      7.1 המשתמש מתחייב שלא לבצע באתר, בשירותים המוצעים בו או באפליקציות המקושרות אליו, כל פעולה שהיא בלתי חוקית לפי דיני מדינת ישראל או הפוגעת בזכויות צד שלישי.
    </Typography>
    <Typography>
      7.2 בין היתר, חל איסור על:<br/>
      <ul>
        <li>העלאה, שידור, הפצה או פרסום של תוכן פוגעני, משמיץ, מאיים, מטריד, גזעני או פורנוגרפי.</li>
        <li>שימוש בתכנים המוגנים בזכויות יוצרים או בזכויות קניין רוחני אחרות, ללא הרשאה מפורשת מבעל הזכויות.</li>
        <li>ביצוע פעולות שעלולות לשבש את פעילות האתר, לפגוע בשרתים או במערכות המחשב הקשורות אליו, או לנסות לעקוף אמצעי אבטחה.</li>
      </ul>
    </Typography>
  </LegalSection>
  <LegalSection title="8. שיפוי">
    <Typography>
      המשתמש מתחייב לשפות ולפצות את בעלת האתר, עובדיה, מנהליה וכל מי מטעמה, בגין כל נזק, הפסד, אובדן רווח, תשלום או הוצאה (לרבות שכר טרחת עורכי דין והוצאות משפט) שייגרמו להם עקב הפרת תנאי שימוש אלה ו/או עקב כל טענה או דרישה מצד שלישי הנובעת ממעשיו או ממחדליו של המשתמש.
    </Typography>
  </LegalSection>
  <LegalSection title="9. הגבלת גיל">
    השימוש באתר ובשירותים המוצעים בו מיועד לאזרחים בגירים (בני 18 ומעלה).<br/>
    קטינים (מתחת לגיל 18) רשאים להשתמש באתר רק לאחר קבלת אישור מפורש מהורה או אפוטרופוס חוקי.<br/>
    עצם השימוש באתר על-ידי קטין מהווה הצהרה כי קיבל את האישור האמור, וכי בעלת האתר לא תישא באחריות לאי-קבלת אישור כאמור.<br/>
    השימוש באתר כפוף לדין הישראלי ולסמכות השיפוט של בתי המשפט בישראל.
  </LegalSection>
  <LegalSection title="10. הדין החל וסמכות השיפוט">
    הדין החל על תנאי שימוש אלה הוא הדין של מדינת ישראל, וסמכות השיפוט הבלעדית נתונה לבתי המשפט המוסמכים במחוז מרכז.
  </LegalSection>
</LegalContentWrapper>;

export default withMainContainer(withTitle('תנאי שימוש', Terms));
